import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { catchError, take } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { OktaService } from '@app/reset-password/components/sent-recover-email/okta.service';
import { environment } from '@env/environment';

@Component({
  selector: 'ecp-sent-recover-email',
  templateUrl: './sent-recover-email.component.html',
  styleUrls: ['./sent-recover-email.component.scss'],
})
export class SentRecoverEmailComponent {
  form: FormGroup = new FormGroup(
    {
      email: new FormControl('', {
        validators: Validators.compose([Validators.required, Validators.email]),
      }),
    },
    {
      updateOn: 'submit',
    },
  );

  hasSubmitted = false;
  isLoading = false;

  constructor(private oktaService: OktaService) {}

  onSubmit(event): void {
    const payload = {
      email: this.form.get('email').value,
      mailjetRequest: {
        tenant: environment.mailjet.tenant,
        templateId: environment.mailjet.forgotPwTemplateId,
        subject: environment.mailjet.forgotPwSubject,
        url:
          environment.baseUrl +
          environment.mailjet.forgotPwUrl +
          this.form.get('email').value,
        from: {
          name: environment.mailjet.from,
          email: environment.mailjet.from,
        },
      },
    };
    if (this.form.invalid) return;

    this.isLoading = true;

    this.oktaService
      .resetPassword(payload)
      .pipe(
        take(1),
        catchError(err => EMPTY),
      )
      .subscribe(response => {
        this.hasSubmitted = true;
        this.isLoading = false;
      });
  }
}
